var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/try-to-string.js
// module id = 131
// module chunks = 0